import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const PublicHeader: React.FC = () => {
    const location = useLocation();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const isActive = (path: string) => {
        return location.pathname === path;
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
    };

    return (
        <header className="bg-gray-50 dark:bg-gray-800 shadow-sm py-4 relative">
            <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="flex h-16 justify-between items-center">
                    <div className="flex items-center">
                        <Link to="/" className="flex items-center text-2xl font-semibold text-gray-900 dark:text-white font-dancing-script">
                            <img src="/images/logo/logo_icon.png" alt="The Brilliance of Blossoms" className="h-8 w-8 mr-3" />
                            The Brilliance of Blossoms
                        </Link>
                    </div>

                    {/* Desktop Navigation */}
                    <div className="hidden md:flex items-center space-x-8">
                        <Link
                            to="/"
                            className={`text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white pb-1 border-b-2 transition-colors ${
                                isActive("/")
                                    ? "border-brand-500 text-gray-900 dark:text-white"
                                    : "border-transparent"
                            }`}
                        >
                            Home
                        </Link>
                        <Link
                            to="/blossoms"
                            className={`text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white pb-1 border-b-2 transition-colors ${
                                isActive("/blossoms")
                                    ? "border-brand-500 text-gray-900 dark:text-white"
                                    : "border-transparent"
                            }`}
                        >
                            Meet the Blossoms
                        </Link>
                        <Link
                            to="/about"
                            className={`text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white pb-1 border-b-2 transition-colors ${
                                isActive("/about")
                                    ? "border-brand-500 text-gray-900 dark:text-white"
                                    : "border-transparent"
                            }`}
                        >
                            About
                        </Link>
                        <Link
                            to="/quiz"
                            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-brand-500 hover:bg-brand-600"
                        >
                            Take the Quiz
                        </Link>
                    </div>

                    {/* Mobile Hamburger Button */}
                    <button
                        onClick={toggleMobileMenu}
                        className="md:hidden inline-flex items-center justify-center p-2 rounded-md text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-brand-500"
                        aria-expanded={isMobileMenuOpen}
                        aria-label="Toggle menu"
                    >
                        {isMobileMenuOpen ? (
                            // Close icon (X)
                            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        ) : (
                            // Hamburger icon
                            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        )}
                    </button>
                </div>

                {/* Mobile Menu Dropdown */}
                <div
                    className={`md:hidden absolute left-0 right-0 top-full bg-gray-50 dark:bg-gray-800 shadow-lg overflow-hidden transition-all duration-300 ease-in-out ${
                        isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                    }`}
                    style={{ zIndex: 50 }}
                >
                    <div className="px-4 pt-2 pb-4 space-y-1">
                        <Link
                            to="/"
                            onClick={closeMobileMenu}
                            className={`block px-3 py-3 rounded-md text-base font-medium ${
                                isActive("/")
                                    ? "bg-brand-500 text-white"
                                    : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-white"
                            }`}
                        >
                            Home
                        </Link>
                        <Link
                            to="/blossoms"
                            onClick={closeMobileMenu}
                            className={`block px-3 py-3 rounded-md text-base font-medium ${
                                isActive("/blossoms")
                                    ? "bg-brand-500 text-white"
                                    : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-white"
                            }`}
                        >
                            Meet the Blossoms
                        </Link>
                        <Link
                            to="/about"
                            onClick={closeMobileMenu}
                            className={`block px-3 py-3 rounded-md text-base font-medium ${
                                isActive("/about")
                                    ? "bg-brand-500 text-white"
                                    : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-white"
                            }`}
                        >
                            About
                        </Link>
                        <Link
                            to="/quiz"
                            onClick={closeMobileMenu}
                            className="block w-full mt-4 px-4 py-3 border border-transparent text-base font-medium rounded-md text-white bg-brand-500 hover:bg-brand-600 text-center"
                        >
                            Take the Quiz
                        </Link>
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default PublicHeader;
